import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { videoFileTypes } from '@app/shared/constants';
import { NotificationDialogComponent } from '@app/shared/dialog/notification-dialog/notification-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { includes, isNil } from 'lodash';

@Component({
  selector: 'app-thumbnails',
  templateUrl: './thumbnails.component.html',
  styleUrls: ['./thumbnails.component.scss'],
})
export class ThumbnailsComponent {
  @Input() maxAssetCount: number = 0;
  @Input() titleText: string = '';
  @Input() indexText: string = '';
  @Input() addText: string = '';
  @Input() assets: { index: number; url: string; type: string }[] = [];
  @Input() selectedAsset: any;
  @Output() selectedAssetChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() assetAdd = new EventEmitter();
  @Output() assetDelete: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    public translate: TranslateService,
    private matDialog: MatDialog,
  ) {}

  onAssetSelected(asset: any) {
    const element = document.getElementById(asset.index);
    if (element) {
      element.scrollIntoView();
      element.scrollIntoView({
        behavior: 'auto',
        block: 'nearest',
        inline: 'start',
      });
    }
    this.selectedAssetChange.emit(asset);
  }

  isSelectedAsset(asset: any) {
    return this.selectedAsset.index === asset.index;
  }

  onAssetAdd() {
    this.assetAdd.emit();
  }

  onAssetDelete(asset: any) {
    if (isNil(asset.asset)) {
      this.matDialog
        .open(NotificationDialogComponent, {
          data: {
            descriptionText: this.translate.instant('teaser.confirmationDialog.deleteConfirmationMessage'),
            descriptionFaClass: 'fa-question-circle fa-2x',
            confirmText: this.translate.instant('teaser.confirmationDialog.clear'),
            declineText: this.translate.instant('teaser.confirmationDialog.cancel'),
            hideClose: true,
          },
          panelClass: ['-md', 'sensor-onboarding-confirmation'],
        })
        .afterClosed()
        .subscribe((confirm) => {
          if (confirm) {
            this.assetDelete.emit(asset);
          }
        });
    } else {
      this.assetDelete.emit(asset);
      this.onAssetSelected(asset);
    }
  }

  public onPreviousClick() {
    const selectedAssetIndex = this.assets.indexOf(this.selectedAsset) - 1;
    if (selectedAssetIndex < 0) {
      this.onAssetSelected(this.assets[this.assets.length - 1]);
    } else {
      this.onAssetSelected(this.assets[selectedAssetIndex]);
    }
  }

  public onNextClick() {
    const selectedAssetIndex = this.assets.indexOf(this.selectedAsset) + 1;
    if (selectedAssetIndex > this.assets.length - 1) {
      this.onAssetSelected(this.assets[0]);
    } else {
      this.onAssetSelected(this.assets[selectedAssetIndex]);
    }
  }

  isVideoType(file: File) {
    return includes(videoFileTypes, file.type.split('/')[1].toLowerCase());
  }
}
